import PropTypes from "prop-types";

function HorizontalLine({ className }) {
  return (
    <div
      className={`${className} mb-[2rem] mt-[1.5rem] border border-grayDisplay-270`}
    />
  );
}

HorizontalLine.propTypes = {
  className: PropTypes.string,
};

export default HorizontalLine;
